'use strict';

export default class KeyShortcutsListener {
  constructor() {
    this.map = {};
    this.intervals = {};

    this.forbiddenElements = ['input', 'select', 'textarea'];

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);

    window.document.addEventListener("keydown", this.onKeyDown);
    window.document.addEventListener("keyup", this.onKeyUp);
  }

  getKey(key) {
    //IE...
    switch (key) {
      case 'Up':
        return 'ArrowUp';
      case 'Down':
        return 'ArrowDown';
      case 'Left':
        return 'ArrowLeft';
      case 'Right':
        return 'ArrowRight';
      default:
        return key;
    }
  }

  onKeyDown(e) {
    let targetElement = (e.target.nodeName || '').toLowerCase();

    if (this.forbiddenElements.indexOf(targetElement) < 0) {
      let key = this.getKey(e.key);

      this.map[key] = true;
      this.map[key.toLowerCase()] = true;
    }
  }

  onKeyUp(e) {
    let key = this.getKey(e.key);

    this.map[key] = false;
    this.map[key.toLowerCase()] = false;
  }

  isShortcutActive(array) {
    for (let i = 0; i < array.length; ++i) {
      if (!this.map[array[i]]) {
        return false;
      }
    }

    return true;
  }

  watch(name, watchCallback, unwatchCallback, keyList) {
    const self = this;

    self.intervals[name] = setInterval(function () {
      if (self.isShortcutActive(keyList)) {
        watchCallback();
      } else {
        unwatchCallback();
      }
    }, 1000 / 24);
  }
}
